import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { CHECK_USER_OPEN_LINK, GLOBAL_STATE, USER_OPEN_LINK, USER_PUBLIC_INFO } from '../constants/actionTypes'

const openLinkSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const generatedLinkSelector = createSelector(openLinkSelector, data => data[USER_OPEN_LINK])

export const checkOpenLinkSelector = createSelector(openLinkSelector, data => data[CHECK_USER_OPEN_LINK])

export const userPublicInfoSelector = createSelector(openLinkSelector, data => data[USER_PUBLIC_INFO])
